import { SET_BRAND, LOGOUT } from "./types";

export const BRAND_BILLING_TYPES = {
  PAID: "PAID",
  FREE: "FREE",
};

const initialState = {
  brand: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_BRAND:
      return {
        ...state,
        brand: { ...state.brand, ...action.payload },
      };
    case LOGOUT:
      return {
        ...state,
        brand: {},
      };

    default:
      return state;
  }
}

export default reducer;
